export default __webpack_public_path__ + "static/media/school2 2.e3c0a6ff.webp";